module.exports = __webpack_public_path__ + "img/smartphone-repair-ok.fa7e27a0.svg";